import SeriesQ from '@/queries/SeriesQ'
import SessionSimulationQ from '@/queries/SessionSimulationQ'
import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'
import { SQL } from '@/client/query'
import { getExperimentArm } from '@/client/services/experiments/session-simulator'
import * as url from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'
import { SAT_BOOTCAMP_WORLD_SLUG } from '@/client/services/worlds'

import { Priority, type TodoItem } from '../types'

export function usePracticeTodos(): TodoItem[] {
  const user = useUser()
  const query = useQuery()

  const experimentArmRegular = getExperimentArm(user.id)
  const experimentArmForTraining = getExperimentArm(user.id, 'training')

  const hostsUpcomingSeries =
    query<boolean>(
      SQL`EXISTS(
        SELECT 1
        ${SeriesQ.where(
          {},
          SQL`${SeriesQ.isHost({ userId: user.id, approved: true })}
          AND ${SeriesQ.hasUpcomingSession()}`
        )}
      )`
    ) ?? false

  const hasCompletedSessionSimulation =
    query<boolean>(
      SQL`EXISTS(
        SELECT 1 ${SessionSimulationQ.where({ userId: user.id })}
      )`
    ) ?? false

  if (hasCompletedSessionSimulation || !hasUserRole(user, 'user:tutor') || !hostsUpcomingSeries) {
    return []
  }

  const todo: TodoItem = {
    worldSlug: SAT_BOOTCAMP_WORLD_SLUG,
    title: 'Start a Practice Session',
    subtitle: 'Use the session simulator to prepare before you host.',
    completed: false,
    link: `${url.getSessionSimulatorUrl()}?src=todo-item`,
    priority: Priority.High,
    emoji: '🤖',
    stepsRemaining: 1,
    targetLevel: 'tutor',
  }

  if (experimentArmForTraining === 'experiment' || experimentArmRegular === 'experiment') {
    return [todo]
  }

  return []
}
